import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='investments-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={
      <>Investment solutions for wherever you are <WidowBlock>in life</WidowBlock></>
    }
    introContent={(
      <>
        <Typography
          id='investments-intro-section-sub-text'
          align='left'
          nextElement='button'>
          With more ways to invest than ever before, it can be hard to make sure your money is working its hardest for you. That&#39;s where we come in. We&#39;ll provide world&#45;class investment expertise based on our time&#45;tested philosophy, disciplined process, and proprietary capital market assumptions. Whether you&#39;re just starting out or you&#39;re ready for more specialized wealth management, you&#39;ll have access to a variety of investment options to help you build your ideal portfolio.
        </Typography>
        <Link
          id='investments-product-intro-cta-fafa'
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          linkUrl='/find-a-financial-advisor/'
          ariaLabel='Get started investing with a financial advisor'>
          Get started
        </Link>
      </>
    )}
  />
);
